import { render, staticRenderFns } from "./HomeSliderImage.vue?vue&type=template&id=3103293b"
import script from "./HomeSliderImage.vue?vue&type=script&lang=js"
export * from "./HomeSliderImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CornerIcon: require('/vercel/path0/components/icons/CornerIcon.vue').default,CornerLink: require('/vercel/path0/components/shared/CornerLink.vue').default,ScrollDownButton: require('/vercel/path0/components/shared/home/ScrollDownButton.vue').default})
